import { Box } from '@chakra-ui/react';

import { useMarketCredentials } from '../hooks';
import { MarketCredentialsButton } from './MarketCredentialsButton';
import { MarketCredentialsModal } from './MarketCredentialsModal';

interface MarketCredentialsSectionProps {
  quoteId: number;
  isEffectiveDateValid?: boolean;
}

export const MarketCredentialsSection = ({
  quoteId,
  isEffectiveDateValid = true,
}: MarketCredentialsSectionProps) => {
  const isDisabled = !isEffectiveDateValid;

  const {
    isFetching,
    error,
    syncStatus,
    syncErrorMessage,
    carriers,
    hasCredentialErrors,
    credentialErrorCarriers,
    refetch,
    updateCredential,
    isUpdating,
    isOpen,
    onOpen,
    onClose,
  } = useMarketCredentials({
    quoteId,
    enabled: !isDisabled,
  });

  return (
    <Box>
      <MarketCredentialsButton
        onClick={onOpen}
        isLoading={isFetching}
        hasCredentialErrors={hasCredentialErrors}
        disabled={isDisabled}
      />

      <MarketCredentialsModal
        isOpen={isOpen}
        onClose={onClose}
        carriers={carriers}
        isLoading={isFetching}
        error={error}
        syncStatus={syncStatus}
        syncErrorMessage={syncErrorMessage}
        credentialErrorCarriers={credentialErrorCarriers}
        onUpdateCredential={updateCredential}
        isUpdating={isUpdating}
        onRetry={refetch}
      />
    </Box>
  );
};
